import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const ContractorsService = {
  async getContractors(page, perPage, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get('contractor/', {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientsContractors(clientId) {
    const res = await axios.get(`contractor/clients/${clientId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientsContractContr(client_id, contrid) {
    const res = await axios.get(
      `contractor/contracts/?client_id=${client_id}&contractor_id=${contrid}`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createContractor(data) {
    const res = await axios.post('contractor/', data);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async updateContractor(data, id) {
    const res = await axios.put(`contractor/${id}/`, data);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteContractor(id) {
    const res = await axios.delete(`contractor/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async autoCompleteContractor(iin) {
    const res = await axios.get(`contractor/esf/autocomplete/${iin}`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async autoCompleteContractorBcc(iin) {
    const res = await axios.get(`v1/client/registration/?iin=${iin}`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
